import { render, staticRenderFns } from "./PFLoanDeductionExceptionReport.vue?vue&type=template&id=20cdfdb4"
import script from "./PFLoanDeductionExceptionReport.vue?vue&type=script&lang=js"
export * from "./PFLoanDeductionExceptionReport.vue?vue&type=script&lang=js"
import style0 from "./PFLoanDeductionExceptionReport.vue?vue&type=style&index=0&id=20cdfdb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports